
import Component from '../../../assets/scripts/modules/component';

class Document extends Component {

  constructor() {
    super(...arguments);
  }

  init() {

    if (navigator.userAgent.match(/(Safari)/gi)) {
      // Safari tends to 'forget' to update the calculated font size.
      window.addEventListener('resize', this.forceRelayout.bind(this));
    }

  }

  forceRelayout() {

    window.requestAnimationFrame(() => this.element.style.border = '10px solid transparent');
    window.requestAnimationFrame(() => this.element.style.border = '');

  }

}

document.documentElement.instance = new Document('document', document.documentElement, { onLoad: true });



// WEBPACK FOOTER //
// ./website/components/structures/document/document.js